<template>
  <span v-b-tooltip.hover :title="`${$t('task.priority.text')}: ${text}`">
    <i :class="icon" class="font-size-24 align-middle mr-2"></i>
    <span v-if="!onlyIcon" class="bold-text">{{ text }}</span>
  </span>
</template>

<script>
export default {
  props: ["priority", "onlyIcon", "size"],
  computed: {
    icon() {
      if (this.priority == "1") {
        return "bx bx-chevron-down low";
      } else if (this.priority == "2") {
        return "iconoir-git-commit medium";
      } else if (this.priority == "3") {
        return "bx bx-chevron-up high";
      } else if (this.priority == "4") {
        return "bx bx-chevrons-up highest";
      }
      return "iconoir-git-commit medium";
    },
    text() {
      if (this.priority == "1") {
        return this.$t("task.priority.low");
      } else if (this.priority == "2") {
        return this.$t("task.priority.medium");
      } else if (this.priority == "3") {
        return this.$t("task.priority.high");
      } else if (this.priority == "4") {
        return this.$t("task.priority.highest");
      }
      return this.$t("task.priority.medium");
    },
  },
};
</script>
<style scoped>
.low {
  color: #458bee;
}
.medium {
  color: #ffc148;
}
.high {
  color: rgb(230, 107, 107);
}
.highest {
  color: red;
}
</style>
